export default "__VITE_ASSET__b21371d8__"